import React, { Component } from 'react';

import axios from "axios/index";





class Countries extends Component{

    constructor(props){
        super(props);
        //this.kraje = this.props.findGroup("kraje");
        //console.log(this.props.findGroup("kraje"));
        this.state = {
            categories:[],
        }

        axios.get(`https://mportalsystem2.btect.sk/api/getdistricts`)
            .then(res => {
                const data = res.data[0];
                this.setState({ categories: data });
            });

    }

    fromCountry($id){
        this.props.setSearchDefs($id);
    }


    render(){
        return(
            <div className="countries">
                <div className="container">
                    <div className="row odsunCont2">
                        <div className="col-md-12">
                            <h2 className="nadpis black">
                                {this.props.findSlug("kraje_nadpis")}
                            </h2>
                            <p className="parag">
                                {this.props.findSlug("kraje_podnadpis")}
                            </p>
                        </div>
                    </div>
                    <div className="row odsBot">
                        {/*{ this.kraje.map(kraj => <li>{kraj.content}</li>)}*/}
                        {
                            this.state.categories.map(data => <div className="col-lg-3 col-md-6 col-sm-6 col-6">
                                <a onClick={() => this.fromCountry(data.id)}>
                                <div className="kraj" style={{backgroundImage: "url("+ data.image+ ")"}} >
                                    <div className="over"></div>
                                    <p className="country_name">{ data.name }</p>

                                </div>
                                </a>
                            </div>)
                        }


                    </div>
                </div>
            </div>
        );
    }
}
export default Countries;